import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { ActivatedRoute } from "@angular/router";
import { QueryParamsService } from "common";
import { routerTransition } from "../../shared/animations/router.animations";
import { OfferBundleListQueryParams } from "../models/offer-bundle-query.model";
import { OfferBundleFilterService } from "../offer-bundle-filter.service";
import { OfferBundleListData } from "./models/offer-bundle-list-data.model";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: "ifb-offer-bundle-list",
    templateUrl: "./offer-bundle-list.component.html",
    styleUrls: ["./offer-bundle-list.component.scss"],
    animations: routerTransition,
    standalone: false
})
export class OfferBundleListComponent implements OnInit {

  tableColumns: string[] = [
    "name",
    "status",
    "expressCheckout",
    "uniqueId",
  ];

  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  @ViewChild(MatSort)
  sort: MatSort;

  queryParams: OfferBundleListQueryParams;

  constructor(
    private route: ActivatedRoute,
    private offerBundleFilterService: OfferBundleFilterService,
    private queryParamsService: QueryParamsService
  ) { }

  data: OfferBundleListData;

  ngOnInit() {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((data: OfferBundleListData) => {
        this.data = data;
      });
    this.route.queryParams.pipe(untilDestroyed(this)).subscribe(it => {
      this.queryParams = this.queryParamsService.init(it);
    });
    this.paginator.pageSize = this.queryParams.limit;
    this.paginator.pageIndex = this.queryParams.skip / this.queryParams.limit;
  }

  filter(): void {
    this.offerBundleFilterService.filter(
      this.data.application.id,
      this.paginator,
      this.sort
    );
  }
}
